import { HsaEndStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import CheckCircleIcon from "@redotech/redo-icons/check-circle.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Handle, Position } from "@xyflow/react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";

export interface HsaEndNodeData {
  step: PartialWithRequiredType<HsaEndStep>;
  deleteElements: (id: string) => void;
  readonly: boolean;
}

/**
 * HSA terminal: a null edge means the survey finished successfully, so this
 * renders as a success state and (unlike the stock EndNode) is deletable.
 */
export function HsaEndNode(data: {
  id: string;
  data: HsaEndNodeData;
  selected?: boolean | undefined;
}) {
  const { t } = useTranslation();

  return (
    <BaseNode
      icon={
        <RedoFeaturedIcon color="success" Icon={CheckCircleIcon} size="xs" />
      }
      onDelete={
        data.data.readonly ? undefined : () => data.data.deleteElements(data.id)
      }
      selected={data.selected}
      step={data.data.step}
      title={t("Survey complete")}
    >
      <Handle id="top" position={Position.Top} type="target" />
    </BaseNode>
  );
}
